export default {
  selectorManager: {
    appendTo: '.styles-container',
  },
}
